import { ShieldCheck, Sparkles, Tag, Truck } from "lucide-react";

export function TrustBadgesBar() {
  const badges = [
    {
      title: "Quality Products",
      desc: "We Don't Just Sell, We Guarantee Quality!",
      icon: ShieldCheck,
      color: "bg-[#087DB5] text-white",
      borderColor: "border-[#087DB5]/30",
      textColor: "text-[#087DB5]"
    },
    {
      title: "Fast & Reliable Delivery",
      desc: "Fast delivery across Addis Ababa & Ethiopia",
      icon: Truck,
      color: "bg-[#00B7B0] text-white",
      borderColor: "border-[#00B7B0]/30",
      textColor: "text-[#00B7B0]"
    },
    {
      title: "Great Prices",
      desc: "Website-exclusive deals & genuine value",
      icon: Tag,
      color: "bg-[#FF8A00] text-white",
      borderColor: "border-[#FF8A00]/30",
      textColor: "text-[#FF8A00]"
    },
    {
      title: "Secure Payments",
      desc: "Cash on delivery & verified payment options",
      icon: ShieldCheck,
      color: "bg-[#073B70] text-white",
      borderColor: "border-[#073B70]/30",
      textColor: "text-[#073B70] dark:text-teal-300"
    }
  ];

  return (
    <section className="mx-auto max-w-[1500px] px-3 sm:px-4">
      <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
        {badges.map((b) => {
          const Icon = b.icon;
          return (
            <div
              key={b.title}
              className="flex items-center gap-3 rounded-2xl border border-slate-200/90 bg-white p-3.5 shadow-2xs transition hover:shadow-md dark:border-white/10 dark:bg-slate-900"
            >
              <div
                className={`grid h-10 w-10 sm:h-12 sm:w-12 shrink-0 place-items-center rounded-xl ${b.color} shadow-sm`}
              >
                <Icon className="h-5 w-5 sm:h-6 sm:w-6" />
              </div>
              <div className="min-w-0">
                <h3 className="text-xs sm:text-sm font-bold tracking-tight text-[#073B70] dark:text-white">
                  {b.title}
                </h3>
                <p className="line-clamp-1 text-[11px] text-slate-500 dark:text-slate-400">
                  {b.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
